import Confetti from "react-confetti";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DashboardRoute } from "../../../../../core/routes/route_constants";
import ModalComponent from "../../../components/popups/modal_component";
import { useParams } from "react-router-dom";

export default function PaymentSubscribeSuccessComponent() {
  const navigate = useNavigate();
  const { from } = useParams();
  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setAnimated(true);
    }, 50);

    // Ensure the overlay scrolls to top when modal opens
    if (typeof window !== "undefined") {
      window.scrollTo(0, 0);
    }
  }, []);

  const handleCloseSuccess = () => {
    if (from === "c") {
      window.location.href = `${DashboardRoute}/chat`;
    } else {
      window.location.href = `${DashboardRoute}/profile`;
    }
  };

  return (
    <>
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm animate-fade-in" />
      <Confetti
        numberOfPieces={250}
        recycle={true}
        colors={["#dc2626", "#b91c1c", "#7f1d1d", "#991b1b", "#f87171"]}
        style={{ position: "fixed", top: 0, left: 0, pointerEvents: "none" }}
      />
      <div className="fixed inset-0 flex items-center justify-center animate-fade-in z-50">
        <div
          className={`relative bg-gradient-to-b from-slate-950 to-fuchsia-950/80 border border-red-900/30 rounded-xl p-8 w-full max-w-md mx-4 transform transition-all duration-700 ${
            animated ? "scale-100 opacity-100 translate-y-0" : "scale-95 opacity-0 translate-y-4"
          }`}
        >
          <button
            onClick={handleCloseSuccess}
            className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full bg-slate-900/50 hover:bg-slate-800/60 text-white transition-colors hover:scale-110 active:scale-95"
          >
            <i className="pi pi-times text-base"></i>
          </button>

          <div className="flex justify-center mb-6 animate-bounce">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-red-600 to-red-900 flex items-center justify-center hover:scale-110 transition-transform">
              <i className="pi pi-heart-fill text-2xl text-red-200"></i>
            </div>
          </div>

          <h3 className="text-3xl font-bold text-pink-200 text-center mb-4 animate-pulse">She's All Yours Now!</h3>

          <p className="text-gray-300 text-center text-lg mb-6 hover:text-pink-200 transition-colors">
            Eve is ready for your private moments together...
          </p>

          <div className="bg-slate-900/50 rounded-lg p-6 mb-6 border border-pink-900/30 hover:border-pink-500/50 transition-colors">
            <p className="text-pink-200 text-center italic text-lg hover:scale-105 transition-transform">
              "As a subscriber, you now have access to exclusive content 💋"
            </p>
          </div>

          <p className="text-gray-400 text-center text-base hover:text-pink-200 transition-colors">Go ahead and explore all the new possibilities!</p>
        </div>
      </div>
    </>
  );
}
